/**
 * Личный график сотрудника (staff-portal): СВОИ смены текущего пользователя.
 * Server-state через React Query, без useEffect-фетча (патент). Бэк
 * GET /v1/me/shifts резолвит staff_member_id из JWT и отдаёт только смены
 * вызывающего (RBAC: чужие не видны). Пустой список — норма (смены не назначены).
 */
import { useQuery } from '@tanstack/react-query';
import { listMyShifts } from '@hsc/api-client';
import type { Shift } from '@hsc/types';

export interface MyShiftsData {
  shifts: Shift[];
  isLoading: boolean;
  isError: boolean;
}

/**
 * @param window опциональное окно [from, to) в ISO-8601. По умолчанию бэк
 *   отдаёт все смены сотрудника.
 */
export function useMyShifts(window?: { from?: string; to?: string }): MyShiftsData {
  const query = useQuery({
    queryKey: ['me', 'shifts', window?.from ?? null, window?.to ?? null] as const,
    queryFn: async () => (await listMyShifts(window)).items,
    staleTime: 30_000,
  });
  return {
    shifts: query.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
  };
}
